import { DOCK_VIEW_LABELS, type DashboardView } from './Common/mobileDashboardDockConstants'
import type { NlsContextValue } from '../nls/nlsProvider'
import type { NlsKey } from '../nls/strings_nls'

type DashboardTranslate = NlsContextValue['t']

export const DASHBOARD_VIEW_LABEL_KEYS: Record<DashboardView, NlsKey> = {
  Timeline: 'NLSDashboardViewTimeline',
  Constellation: 'NLSDashboardViewConstellation',
  Radar: 'NLSDashboardViewRadar',
  Sandfall: 'NLSDashboardViewSandfall',
  Journey: 'NLSDashboardViewJourney',
  Grid: 'NLSDashboardViewGrid',
  Heatmap: 'NLSDashboardViewHeatmap',
  Stripboard: 'NLSDashboardViewStripboard',
  WarRoom: 'NLSDashboardViewWarRoom',
  Leaderboard: 'NLSDashboardViewReliability',
  Perimeter: 'NLSDashboardViewPerimeter',
  LootDrop: 'NLSDashboardViewLootDrop',
  Flowband: 'NLSDashboardViewFlowband',
  Burnshore: 'NLSDashboardViewBurnshore',
  Cadence: 'NLSDashboardViewCadence',
}

export const DASHBOARD_VIEW_TOOLTIP_KEYS: Record<DashboardView, NlsKey> = {
  Timeline: 'NLSDashboardViewTooltipTimeline',
  Constellation: 'NLSDashboardViewTooltipConstellation',
  Radar: 'NLSDashboardViewTooltipRadar',
  Sandfall: 'NLSDashboardViewTooltipSandfall',
  Journey: 'NLSDashboardViewTooltipJourney',
  Grid: 'NLSDashboardViewTooltipGrid',
  Heatmap: 'NLSDashboardViewTooltipHeatmap',
  Stripboard: 'NLSDashboardViewTooltipStripboard',
  WarRoom: 'NLSDashboardViewTooltipWarRoom',
  Leaderboard: 'NLSDashboardViewTooltipReliability',
  Perimeter: 'NLSDashboardViewTooltipPerimeter',
  LootDrop: 'NLSDashboardViewTooltipLootDrop',
  Flowband: 'NLSDashboardViewTooltipFlowband',
  Burnshore: 'NLSDashboardViewTooltipBurnshore',
  Cadence: 'NLSDashboardViewTooltipCadence',
}

export const getDashboardViewDockLabels = (t: DashboardTranslate): Record<DashboardView, { icon: string; label: string; tooltip: string }> =>
  Object.fromEntries(
    Object.entries(DOCK_VIEW_LABELS).map(([view, item]) => [
      view,
      {
        icon: item.icon,
        label: t(DASHBOARD_VIEW_LABEL_KEYS[view as DashboardView]),
        tooltip: t(DASHBOARD_VIEW_TOOLTIP_KEYS[view as DashboardView]),
      },
    ]),
  ) as Record<DashboardView, { icon: string; label: string; tooltip: string }>

export const getDashboardControlLabels = (t: DashboardTranslate) => ({
  scrollLeftLarge: t('NLSDashboardActionScrollLeftLarge'),
  scrollLeft: t('NLSDashboardActionScrollLeft'),
  scrollRight: t('NLSDashboardActionScrollRight'),
  scrollRightLarge: t('NLSDashboardActionScrollRightLarge'),
  zoomOut: t('NLSDashboardActionZoomOut'),
  zoomIn: t('NLSDashboardActionZoomIn'),
  fitTimeline: t('NLSDashboardActionFitFullTimeline'),
  focusSelectedItem: t('NLSDashboardActionFocusSelectedItem'),
  showViewLegend: t('NLSDashboardActionShowViewLegend'),
  hideViewLegend: t('NLSDashboardActionHideViewLegend'),
  viewLegend: t('NLSDashboardActionViewLegend'),
  expandDashboardView: t('NLSDashboardActionExpandDashboardView'),
  exitExpandedView: t('NLSDashboardActionExitExpandedView'),
})

export const getDashboardCanvasWelcomePhrases = (t: DashboardTranslate): string[] => [
  t('NLSDashboardEmptyWelcomePhraseStart'),
  t('NLSDashboardEmptyWelcomePhraseCreate'),
  t('NLSDashboardEmptyWelcomePhraseManage'),
  t('NLSDashboardEmptyWelcomePhraseMotion'),
]
